import NativeTouchableOpacity from './naitve-touchable-opacity';
import TouchableOpacity from './touchable-opacity';

export default TouchableOpacity;
export {NativeTouchableOpacity};
